/**
 * Labstep - Table Handles Controller
 *
 * Main controller component for BlockNote-style table handles with menu functionality
 */

import React, { type FC } from 'react';
import { useUIPluginState } from '../../nodes/table/hooks/useUIPluginState';
import type { TableHandlesState } from '../../nodes/table/plugins/table-handles';
import { TableHandles } from './TableHandles';

interface TableHandlesControllerProps {
  tableHandlesPlugin: any; // TODO: Type this properly
  view: any; // EditorView from prosemirror-view
}

export const TableHandlesController: FC<
  TableHandlesControllerProps
> = (props) => {
  const state = useUIPluginState<TableHandlesState>(
    props.tableHandlesPlugin.onUpdate.bind(props.tableHandlesPlugin),
  );

  if (!state?.show || !state?.hoveredCell) {
    return null;
  }

  return (
    <TableHandles
      view={props.view}
      tableNode={state.tableNode}
      tablePos={state.tablePos || 0}
      hoveredCell={state.hoveredCell}
    />
  );
};
